import { makeStyles } from '@material-ui/core/styles'
import PageMetaData from '@v4/utils/data/PageMetaData'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			maxWidth: theme.spacing(78),
			width: '100%',
		},
		content: {
			display: 'flex',
			flexDirection: 'column',
			width: '100%',
		},
		[PageMetaData.ALIGNMENT.LEFT]: {
			alignItems: 'flex-start',

			'& $text': {
				textAlign: 'left',
			},
		},
		[PageMetaData.ALIGNMENT.RIGHT]: {
			alignItems: 'flex-end',

			'& $text': {
				textAlign: 'right',
			},
		},
		[PageMetaData.ALIGNMENT.CENTER]: {
			alignItems: 'center',

			'& $text': {
				textAlign: 'center',
			},
		},
		image: {
			display: 'flex',
			justifyContent: 'center',
			height: theme.spacing(6),
			width: theme.spacing(6),
			'& img': {
				height: '100%',
				objectPosition: 'center bottom',
				objectFit: 'contain',
			},
		},
		text: {},

		buttonWrap: {
			width: '100%',
			display: 'flex',
			marginTop: theme.spacing(5),
			justifyContent: ({ metaData }) => metaData.itemAlignment?.contentAlignment(),

			[theme.breakpoints.down('xs')]: {
				justifyContent: ({ mobileContentAlignment }) => mobileContentAlignment?.contentAlignment(),
			},
		},

		button: {
			width: 'auto',

			[theme.breakpoints.down('xs')]: {
				width: ({ mobileButtonWidth }) => (mobileButtonWidth?.isWide ? '100%' : 'auto'),
			},
		},
	}),
	{ name: 'CallToAction-item-10_11' },
)

export default useStyles
